<template>
  <div id="cruiseTrack" >
    <el-dialog
      title="巡航轨迹"
      width="50rem"
      top="2rem"
      :append-to-body="true"
      :close-on-click-modal="false"
      :visible.sync="showDialog"
      :destroy-on-close="true"
      @close="close()"
    >
      <div>
        <div v-if="cruiseNum === ''" >
          <el-table ref="channelListTable" :data="cruiseTrackList" style="width: 100%" height="30rem"
                    header-row-class-name="table-header">
            <el-table-column prop="number" label="编号" min-width="80">
            </el-table-column>
            <el-table-column prop="name" label="名称" min-width="180">
            </el-table-column>
            <el-table-column label="操作" min-width="120" fixed="right">
              <template slot-scope="scope">
                <el-button size="medium" type="text" @click="getCruiseTrack(scope.row)">查看</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="cruiseNum !== ''">
          <el-button icon="el-icon-back" size="mini" style="font-size: 20px; color: #000;" type="text" @click="showCruiseTrackList" ></el-button>
          <el-table ref="channelListTable" :data="cruiseList" style="width: 100%" height="30rem"
                    header-row-class-name="table-header">
            <el-table-column prop="presetIndex" label="预置位编号" min-width="80">
            </el-table-column>
            <el-table-column label="预置点停留时间" min-width="120" fixed="right">
              <template slot-scope="scope">
                <span>{{scope.row.stayTime}}秒</span>
              </template>
            </el-table-column>
            <el-table-column prop="speed" label="云台速度" min-width="80">
            </el-table-column>
            <!--          <el-table-column label="操作" min-width="120" fixed="right">-->
            <!--            <template slot-scope="scope">-->
            <!--              <el-button size="medium" type="text" @click="getCruiseTrack(scope.row)">查看</el-button>-->
            <!--            </template>-->
            <!--          </el-table-column>-->
          </el-table>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: "sdCardStatus",
  components: {},
  created() {},
  data() {
    return {
      showDialog: false,
      cruiseTrackList: [],
      cruiseList: [],
      cruiseNum: '',
    };
  },
  methods: {
    openDialog: function (deviceId, channelId, callback) {
      this.deviceId = deviceId;
      this.channelId = channelId;
      this.showDialog = true;
      this.submitCallback = callback;
      this.getCruiseTrackList()
    },
    getCruiseTrackList: function () {
      this.$axios({
        method: 'get',
        url: '/api/device/query/cruise-track-list',
        params: {
          deviceId: this.deviceId,
          channelId: this.channelId,
        }
      }).then( (res)=> {
        this.cruiseTrackList = res.data.data
        console.log(res)
      }).catch((error)=> {

      });
    },
    getCruiseTrack: function (item) {
      this.cruiseNum = item.number
      this.$axios({
        method: 'get',
        url: '/api/device/query/cruise-track',
        params: {
          deviceId: this.deviceId,
          channelId: this.channelId,
          number: item.number,
        }
      }).then( (res)=> {
        this.cruiseList = res.data.data.cruisePointList
        console.log(res)
      }).catch((error)=> {

      });
    },
    close: function () {
      this.showDialog = false;
    },
    showCruiseTrackList: function () {
      this.cruiseNum = '';
    },
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/dialog/cruiseTrack.vue